var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmartphone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.42 16.599V1.397A1.4 1.4 0 0013.024 0H4.977A1.4 1.4 0 003.58 1.397v15.206A1.4 1.4 0 004.977 18h8.046a1.405 1.405 0 001.398-1.401zM4.482 3.239h9.035v10.23H4.48V3.24zM4.977.902h8.046c.272 0 .497.22.497.496v.942H4.48v-.942c0-.275.224-.496.496-.496zm-.496 15.698v-2.232h9.035v2.232c0 .272-.22.496-.496.496H4.977a.497.497 0 01-.496-.496z",
    fill: "#5268FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.913 15.32H8.085a.452.452 0 100 .904h1.828a.452.452 0 100-.905z",
    fill: "#5268FB"
  })));
}

export default __webpack_public_path__ + "./fonts/smartphone.c5f84c45b1811179fbac768309d23f41.svg";
export { SvgSmartphone as ReactComponent };